































import Vue from "vue";

export default Vue.extend({
  name: "DeleteEvent",
  props: {
    showEditor: Boolean,
  },
  data() {
    return {
      deleteOption: "occurrence",
    };
  },
  computed: {
    showModal(): any {
      return this.showEditor;
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        this.deleteOption = "occurrence";
      }
    },
  },
  methods: {
    handleClickDeleteOption(name) {
      this.deleteOption = name;
    },
    handleCancel() {
      this.$emit("cancel");
    },
  },
});
